import { Injectable } from '@angular/core';
import { AgentAskQuery, AgentAskResponse } from '@app/data';
import { ApiService } from '@app/gateway';

/**
 * Dashboard assistant. Questions go to dash-api; fiscal tools run server-side against nfeclass.
 */
@Injectable({ providedIn: 'root' })
export class AgentService {
  constructor(protected readonly apiService: ApiService) {}

  public async ask(data: AgentAskQuery): Promise<AgentAskResponse> {
    try {
      const response: AgentAskResponse = await this.apiService.post<AgentAskResponse>({ path: 'agent/ask', data });
      return response;
    } catch (error: unknown) {
      const message: string = error instanceof Error ? error.message : 'Não foi possível consultar o assistente agora.';
      throw new Error(message, { cause: error });
    }
  }
}
